// Generated code for Big.Domain.Enums.ProfessionalPositionEvidenceCategoryType.
// Edit _Enum.tst to change the generated output.

export enum ProfessionalPositionEvidenceCategoryType {
    onbekend = 0,
    conformGeregistreerdeBeroep = 1,
    docent = 2,
    leidinggevende = 3,
    promovendus = 4,
    onderzoeker = 5,
    profielarts = 6,
    specialistInOpleiding = 7,
    pgbZorgverlener = 8,
    adviseur = 9,
    arts = 10,
    fysio = 11,
    pilot = 12
}
(ProfessionalPositionEvidenceCategoryType as any).name = 'ProfessionalPositionEvidenceCategoryType';
